import Defaults from '~/scripts/constants/defaults';
import Lang from '~/scripts/services/model/lang';

angular.module('app')
	.controller('ModalChatAdminCtrl', /* @ngInject */ function ($uibModalInstance, $scope, node, NodeService) {
		$scope.node = node;
		$scope.canDelete = () => node.checkDroit(Defaults.DROIT.DELETE);

		$scope.save = () => {
			$uibModalInstance.close($scope.node);
		};

		$scope.delete = () => {
			NodeService.delete($scope.node.kid).then(deleted => {
				$uibModalInstance.close($scope.node);
			});
		};

		$scope.close = () => {
			$uibModalInstance.dismiss('cancel');
		};
	});
